import './ghtSchedule.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import { authKey, GET_SCHEDULE_NO_LIST, GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO, GET_STAKEHOLDER_CATEGORY, PRINT_DOWNLOAD_DATA, APPROVE_STAKEHOLDER_SCHEDULE } from '../../../common/URLs';

import jwt from 'jwt-decode';
import DatePicker from "react-datepicker";
import { DataGrid } from '@mui/x-data-grid';
import { Button, Select, InputLabel, Grid, FormControl, Box, Card, TextField, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD } from '../../../common/constants';
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import addDays from 'date-fns/addDays';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import apiClient from '../../../axios';

function GhtSchedule(props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const location = useLocation();

  const [searchVisible, setSearchvisible] = useState(false);
  const [scheduleno, setScheduleno] = useState([]);
  const [weeklyscheduledata, setWeeklyscheduledata] = useState([]);
  const [stakeholderType, setStakeholderType] = useState("");
  //const[stakeholderURN,setStakeholderURN]= useState("");
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [hideHarvesting, setHideHarvesting] = useState();
  const [selectedUrn, setSelectedUrn] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  //const [selectedType, setSelectedType] = useState();
  //const [plantconsumptiondate, setPlantconsumptiondate] = React.useState(new Date());
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(addDays(new Date(), 7));
  const [printHarvestingInstruction, setPrintHarvestingInstruction] = useState();

  const [approveButtonData, setApproveButtonData] = useState();
  const [approveDataList, setApproveDataList] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);


  const [searchFilter, setSearchFilter] = useState({
    "weeklyScheduleNumber": "",
  });

  const harvestingDetails = (cellValues) => {

    navigate('./harvestingDetails', {
      state: { selectedRow: cellValues.row }
    });
  }
  useEffect(() => {
    setSelectedUrn(location?.state?.data);
  }, []);

  useEffect(() => {
    if (scheduleno && scheduleno.length > 0)
      getWeeklySchedule(null, scheduleno[0]);
  }, [stakeholderDetails, scheduleno])

  useEffect(() => {
    if (selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN) {
      getStakeDetails();
    }
  }, [selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN]);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        //getWeeklySchedule(null, scheduleno[0]);
        getScheduleNo();
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  }

  useEffect(() => {

    getWeeklySchedule(null, searchFilter?.weeklyScheduleNumber);

  }, [fromDate, toDate]);

  const getScheduleNo = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_SCHEDULE_NO_LIST,
        {
          "stakeholderUrn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setScheduleno(response.data.scheduleNoList);
        //getWeeklySchedule({ target: { value: response.data.scheduleNoList[0] } });
        setSearchFilter({ "weeklyScheduleNumber": response.data.scheduleNoList[0] })
        loaderService.hideLoader();
      })
      .catch(function (error) {
        // console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getWeeklySchedule = (e, serachvalue) => {
    if (stakeholderDetails?.category) {
      let weeklyScheduleNo = e?.target?.value;
      if (weeklyScheduleNo) { setSearchFilter({ "weeklyScheduleNumber": weeklyScheduleNo }) }
      apiClient
        .post(GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO,
          {
            "weeklyScheduleNumber": stakeholderDetails?.category === "Grower" ? null : weeklyScheduleNo ? weeklyScheduleNo : serachvalue ? serachvalue : null,
            "stakeholderUrn": selectedUrn?.urn ? selectedUrn?.urn : decoded.extension_URN,
            "stakeholderType": stakeholderDetails?.category,
            "activityType": location?.state?.data?.activityTypeLoad,
            "pickUpFromDate": (stakeholderDetails?.category === "HIT" || stakeholderDetails?.category === "Transporter") ? null : fromDate,
            "pickUpToDate": (stakeholderDetails?.category === "HIT" || stakeholderDetails?.category === "Transporter") ? null : toDate

          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          setWeeklyscheduledata(response.data.weeklySchedulePlanDetailsList);
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
          toast.error(error.message);
        });
    }
  }
  const handleChange = (e) => {
    if (e.target.name === "weeklyScheduleNumber") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }

  function searchScheduleDetails(e) {
    e.preventDefault();
    getWeeklySchedule(e, searchFilter.weeklyScheduleNumber);
  }

  const columns = [
    { field: 'weeklyScheduleNumber', headerName: t('pit.scheduleNo'), width: 250 },
    { field: 'scheduleLineNumber', headerName: t('pit.scheduleLineNo'), width: 150 },
    {
      field: 'schedulePickupDate', headerName: t('pit.pickUpDate'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: t('pit.quantity'), width: 150 },
    {
      field: 'firstPartyUrn', headerName: t('pit.urn1stParty'), width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'firstPartyContactNo', headerName: t('pit.contactDetails1stParty'), width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'firstPartyLocationName', headerName: t('pit.location1stParty'), width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
            :
            <> {cellValues?.row?.firstPartyLocationName} </>
        );
      }
    },
    { field: 'secondPartyUrn', headerName: t('pit.urn2ndParty'), width: 150 },
    { field: 'secondPartyContactNo', headerName: t('pit.contactDetails2ndDetails'), width: 150 },
    { field: 'secondPartyLocationName', headerName: t('pit.location2ndParty'), width: 150 },
    {
      field: 'scheduledDeliveryDate', headerName: t('pit.deliveryDate'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: t('pit.poNo'), width: 150 },
    { field: 'landId', headerName: t('pit.landId'), width: 150, hide: stakeholderDetails?.category != "HIT" },
    { field: 'inventoryType', headerName: t('pit.typeOfInventory'), width: 150 },

    {
      field: 'isScheduledApproved', headerName: t('pit.approvalStatus'), width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Rejected';
        }
        else {
          return '';
        }
      },
      getCellValue: (params) => {
        if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
          return <>{params?.row?.isScheduledApproved}</>;
        } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
          return <>{params?.row?.isFirstPartyApproved}</>;
        } else {
          return <>{params?.row?.isSecondPartyApproved}</>;
        }
      },
    },
    // { field: '', headerName: 'Action', width: 100 },

    {
      field: t('reg.actions'), width: 200, hide: stakeholderDetails?.category != "HIT",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => harvestingDetails(cellValues)}
          >
            {t('pit.harvestingDetails')}
          </Button>
        );
      }
    },
    {
      field: t('pit.print'), width: 150, hide: stakeholderDetails?.category != "HIT",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => printHarvestInstructions("print", cellValues)}>
            {t('pit.print')}
          </Button>
        );
      }
    }
  ];

  const printHarvestInstructions = (action, cellValues) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": cellValues?.row?.id,
          "printDetailsType": "weekly_schedule",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setPrintHarvestingInstruction(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  // const onApprove = (e) => {
  //   e.preventDefault();
  //   onApproveButtonClick(true);
  // }

  // const onReject = (e) => {
  //   e.preventDefault();
  //   onApproveButtonClick(false);
  // }

  const onConfirmApprove = () => {
    handleConfirmClose();
    onApproveButtonClick(true);
  }

  const onApprove = (e) => {
    handleConfirmOpen();
  }

  const onConfirmReject = (e) => {
    handleConfirmClose2();
    onApproveButtonClick(false);
  }

  const onReject = (e) => {
    handleConfirmOpen2();
  }



  const onApproveButtonClick = (approval) => {
    loaderService.showLoader();
    let data = selectedRows.map(selectedRow => {
      return {
        "stakeholderType": stakeholderDetails?.category,
        "weeklyScheduleNumber": selectedRow.weeklyScheduleNumber,
        "scheduleLineNumber": selectedRow.scheduleLineNumber
      }
    })
    apiClient
      .post(
        APPROVE_STAKEHOLDER_SCHEDULE,
        {
          "lstStakeholderWeeklyScheduleApproveDTO": [
            ...data
          ],
          "isApproved": approval
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        setApproveButtonData(response.data);
        getWeeklySchedule(null, searchFilter?.weeklyScheduleNumber);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (approveButtonData) {
      if (approveButtonData.isSuccess === true) {
        toast.success(approveButtonData?.message);
        // handleLogModalOpen2();
      } else {
        toast.error(approveButtonData?.message ? approveButtonData?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [approveButtonData]);

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT01</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            {t('pit.weeklyPickupPlan')}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1} hidden={stakeholderDetails}>
            <>
              <Stack direction="row" spacing={1}>
                <Button variant="contained" disabled={selectedRows?.length < 1} onClick={(e) => onApprove(e)} startIcon={<ApproveIcon />}>
                  Approve
                </Button>
                <Button variant="contained" disabled={selectedRows?.length < 1} onClick={(e) => onReject(e)} startIcon={<CancelIcon />}>
                  Reject
                </Button>
              </Stack>
            </>
          </Stack>
        </Stack>
        {/* <Typography variant="h5" gutterBottom>{t('pit.weeklyPickupPlan')}</Typography> */}
        <Card>
          <CardContent>
            {stakeholderDetails?.category === "Grower" || stakeholderDetails?.category === "LLE" ?
              <Grid container spacing={2} mb={1}>
                {/* <p>{t('pit.scheduleFrom')}</p>
                <DatePicker className='dateField'
                  label="Scheduled from"
                  selected={fromDate}
                  dateFormat="dd/MM/yyyy"
                  name="pickUpFromDate"
                  onChange={date => setFromDate(date)}
                />
                <p>{t('pit.scheduleTo')}</p>
                <DatePicker className='dateField'
                  label="Scheduled to"
                  selected={toDate}
                  dateFormat="dd/MM/yyyy"
                  name="pickUpToDate"
                  onChange={date => setToDate(date)}
                /> */}

                <Grid item xs={12} lg={4}>
                  <FormControl fullWidth >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label={t('pit.scheduleFrom')}
                        inputFormat="DD/MM/YYYY"
                        name="pickUpFromDate"
                        value={fromDate}
                        onChange={date => setFromDate(date)}
                        // onChange={(e) => { handleChangeDate(e) }}
                        renderInput={(params) => <TextField size="small" {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <FormControl fullWidth >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        value={toDate}
                        // onChange={handleDateChange}
                        onChange={date => setToDate(date)}
                        // minDate={addDays(new Date(), 7)} // Set minimum date to one week later
                        inputFormat="DD/MM/YYYY"
                        label={t('pit.scheduleTo')}
                        renderInput={(params) => <TextField size="small" {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12} lg={4}>
                  <Button variant="contained" onClick={(e) => searchByDate(e)} >Search
                  </Button>
                </Grid> */}
              </Grid> :
              <>
                {/* <p style={{ marginTop: "1vh" }}>{t('pit.scheduleNo')}:</p> */}
                <Grid container spacing={2} mb={1}>
                  <Grid item xs={6} lg={4} mb={1}>
                    <FormControl fullWidth size="small">
                      <InputLabel>{t('pit.scheduleNo')} </InputLabel>
                      <Select
                        label={t('pit.scheduleNo')}
                        name='weeklyScheduleNumber'
                        // disabled={isDisabled()}
                        value={searchFilter.weeklyScheduleNumber}
                        onChange={(e) => getWeeklySchedule(e)}
                      >
                        <MenuItem selected={searchFilter.weeklyScheduleNumber ? true : false}>Select</MenuItem>
                        {scheduleno.map((schNo, index) => {
                          return <MenuItem selected={index === 0 ? true : false} value={schNo}>{schNo}</MenuItem>
                        }
                        )
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <select className='ght-dropdown' onChange={(e) => getWeeklySchedule(e)}>
              <option selected={searchFilter.weeklyScheduleNumber ? true : false}>select</option>
              {scheduleno.map(
                (schNo, index) => {
                  return <option selected={index === 0 ? true : false} value={schNo}>{schNo}</option>
                }
              )
              }
            </select> */}
                  {/* <Grid item xs={6} lg={4}>
                <Button variant="contained" color="primary" sx={{ minWidth: 100, mt: 1 }} onClick={(e) => { e.preventDefault(); setSearchvisible(!searchVisible) }}>
                  Search
                </Button>
              </Grid> */}

                </Grid>

                {searchVisible &&
                  <>
                    <div>
                      <input className='search-field' type="text" placeholder='Search' name="weeklyScheduleNumber" value={searchFilter.weeklyScheduleNumber} onChange={(e) => handleChange(e)} ></input>
                      <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh" }} onClick={(e) => searchScheduleDetails(e)}>
                        <SearchIcon />
                      </button>
                    </div>
                  </>
                }</>

            }

            <Box style={{ height: 400, width: '100%' }}>
              {
                weeklyscheduledata &&
                <DataGrid rows={weeklyscheduledata}
                  columns={columns}
                  pageSize={10}
                  components={{ Toolbar: QuickSearchToolbar }}
                  checkboxSelection={!stakeholderDetails}
                  onSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedRowData = weeklyscheduledata?.filter((row) =>
                      selectedIDs.has(row.id.toString())
                    )
                    setSelectedRows(selectedRowData);
                  }}
                  isRowSelectable={(params) => !((params.row.isScheduledApproved === true || params.row.isScheduledApproved === false) || (params.row.isFirstPartyApproved === true || params.row.isFirstPartyApproved === false) || (params.row.isSecondPartyApproved === true || params.row.isSecondPartyApproved === false))}

                />

              }
            </Box>
          </CardContent>
        </Card>
        <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
        <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject" />

      </Container>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={approveButtonData?.message ? approveButtonData?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default GhtSchedule;